"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PATTERN_TYPES = exports.SUBMENU_TYPES = exports.MENU_ACTION_TYPES = void 0;
var MENU_ACTION_TYPES = {
  // default action type (API)
  // 0 = 無 1 = 分頁設定 2 = 連結設定 3 = 商品搜尋 5 = 購物車 6 = 語系選單 7 = 幣值選單 8 = 會員功能 Ref to MENU_FUNCTION_ENUM
  NONE: 0,
  PAGE: 1,
  LINK: 2,
  SEARCH: 3,
  CART: 5,
  LOCALE: 6,
  CURRENCY: 7,
  AUTH: 8,
  // custom action type
  SEARCH_BAR: 'searchBar',
  AUTH_LOGOUT: 'logout'
};
exports.MENU_ACTION_TYPES = MENU_ACTION_TYPES;
var SUBMENU_TYPES = {
  DROP_DOWN: 'DROP_DOWN',
  LARGE_MENU: 'LARGE_MENU',
  LARGE_MENU_WITH_IMAGE: 'LARGE_MENU_WITH_IMAGE',
  LARGE_MENU_WITH_PRODUCTS: 'LARGE_MENU_WITH_PRODUCTS'
};
exports.SUBMENU_TYPES = SUBMENU_TYPES;
var PATTERN_TYPES = {
  SOLID: 0,
  BORDER: 1,
  UNDERLINE: 2,
  UNDERLINE_THICK: 3,
  ROUNDED_CORNER: 4
};
exports.PATTERN_TYPES = PATTERN_TYPES;